module.exports = __webpack_public_path__ + "static/media/22.6610f469.jpg";